import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=203b139c&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=203b139c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b139c",
  null
  
)

export default component.exports